export const ENVIRONMENTS = {
  DEVELOPMENT: 'development',
  PRODUCTION: 'production',
  STAGING: 'staging',
  STAGING_NEW: 'staging_new',
  QODOST: 'qodost',
  TEST: 'test',
  AIRGAPPED: 'airgapped',
} as const;
